import advancedSearchComponent from './advanced-search.component';

const advancedSearchModule = angular.module('advancedSearch', [
])
  .component('advancedSearch', advancedSearchComponent)
  .name;

export default advancedSearchModule;
